import React from 'react'
import PropTypes from 'prop-types'
import DsButton from 'components/ds/Button'

const toVariant = (variant, color) => {
  if (variant === 'text') return 'ghost'
  if (variant === 'outlined') return 'secondary'
  if (color === 'secondary') return 'accent'
  return 'primary'
}

const Button = React.forwardRef(function Button(props, ref) {
  const {
    color = 'primary',
    variant = 'contained',
    size = 'medium',
    children,
    loading,
    disabled,
    fullWidth,
    component,

    disableElevation,
    disableRipple,
    disableFocusRipple,
    disableTouchRipple,
    focusRipple,
    centerRipple,
    TouchRippleProps,
    ...otherProps
  } = props

  return (
    <DsButton
      ref={ref}
      variant={toVariant(variant, color)}
      size={size === 'medium' || size === 'small' || size === 'large' ? size : 'medium'}
      block={!!fullWidth}
      as={component}
      loading={loading}
      disabled={loading || disabled || false}
      {...otherProps}
    >
      {children}
    </DsButton>
  )
})

Button.propTypes = {
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,

  component: PropTypes.elementType,
}

export default Button
